import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class LookupTableNavigation extends KeyboardNavigation {

    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string
    ): DefaultFocusStatusModel | null {
        const statuses = this.defaultFocusStatus.statuses;
        const currentIndex = statuses.indexOf(currentElement);
        const groupVariables = this.defaultFocusStatus.statuses.filter((status) => status.lookupTableGroupType === currentElement.lookupTableGroupType);
        const isForward = eventKey === "ArrowDown" || eventKey === "ArrowRight";
        const isBackward = eventKey === "ArrowUp" || eventKey === "ArrowLeft";
        const buttonType = currentElement.elementId.split("_")[currentElement.elementId.split("_").length - 1];
        if (!isForward && !isBackward) return null;
        if (currentElement.lookupTableGroupType === 'lookupTableHeader') {
            const step = isForward ? 1 : -1;
            let startIndex = currentIndex + step;

            for (let i = startIndex; isForward ? i < statuses.length : i >= 0; i += step) {
                const element = statuses[i];
                const isInGroup = groupVariables.includes(element);
                const hasRef = element.elementRef?.current;
                const isSameElement = element.elementId != currentElement.elementId;

                if (!isInGroup || !hasRef || !isSameElement) continue;

                if ((eventKey === "ArrowRight" || eventKey === "ArrowLeft") && element.elementId.includes(buttonType)) {
                    return element;
                } else if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
                    if (!element.elementId.includes(buttonType)) {
                        return element;
                    }
                }
            }
        } else if (currentElement.lookupTableGroupType === 'lookupTableRow' &&
            (eventKey === "ArrowDown" || eventKey === "ArrowUp")) {
            const step = isForward ? 1 : -1;
            const parentElement = currentElement.elementRef.current.parentElement;
            const childNodes = Array.from(parentElement.childNodes).filter((node: ChildNode) =>
                node.nodeType === Node.ELEMENT_NODE &&
                (node as HTMLElement).id
            );

            // Find the current element's position in the child nodes
            const currentIndex = childNodes.findIndex(node =>
                (node as HTMLElement).id === currentElement.elementId
            );

            // Start from the next/previous position
            for (
                let i = currentIndex + step;
                isForward ? i < childNodes.length : i >= 0;
                i += step
            ) {
                const nextHtmlElement = childNodes[i] as HTMLElement;
                const nextElement = this.defaultFocusStatus.statuses.find(
                    status => status.elementId === nextHtmlElement.id
                );

                if (!nextElement) continue;

                const isSameGroup = nextElement.lookupTableGroupType === currentElement.lookupTableGroupType;
                if (
                    isSameGroup &&
                    nextElement.elementId !== currentElement.elementId &&
                    nextElement.elementRef?.current
                ) {
                    return nextElement;
                }
            }
        }
        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index + 1, len = this.defaultFocusStatus.statuses.length; i < len; i++) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];

            if (!elementFocusStatus.elementRef?.current) {
                elementFocusStatus.elementRef.current = document.getElementById(elementFocusStatus.elementId);
            }

            if (elementFocusStatus.elementId !== currentElement.elementId &&
                elementFocusStatus.elementRef.current && elementFocusStatus.lookupTableGroupType != currentElement.lookupTableGroupType) {
                if (currentElement.lookupTableGroupType === "lookupTableHeader" && elementFocusStatus.lookupTableGroupType === "lookupTableRow") {
                    return this.findFirstFocusableElementTableBody(elementFocusStatus);
                }
                return elementFocusStatus;
            }
        }
        return null;
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index - 1; i >= 0; i--) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];
            if (elementFocusStatus.elementId !== currentElement.elementId &&
                elementFocusStatus.elementRef?.current &&
                elementFocusStatus.lookupTableGroupType != currentElement.lookupTableGroupType) {
                return elementFocusStatus;
            }
        }
        return null;
    }
}